define('viewModels/privileged/composer/forms/qualityScore/QuestionScore',[
    'lib/knockout',
    'viewModels/ViewModel'
], function (
    ko,
    ViewModel
) {
    "use strict";

    var QuestionScoreViewModel = ViewModel.extend(function questionScoreVm_init(questionScoreModel) {
        var self = this;

        // Returns the underlying model; used by the editor to save
        self.getModel = function () {
            return questionScoreModel;
        };

        // Model Properties
        self.id = questionScoreModel.id;
        self.modelId = questionScoreModel.modelId;
        self.score = questionScoreModel.score;

    });
    return QuestionScoreViewModel;
});

